import { createApp } from 'vue'
import App from './App.vue'

import * as global_utils from '@/utils/global_utils'
import Ant from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import * as Icons from '@ant-design/icons-vue'
import { message } from 'ant-design-vue';
import '@/assets/css/global.css'
import axios_service from '@/utils/request'
import * as echarts from 'echarts/core';
import router from '@/components/router/index'
// import '@/assets/fonts/fonts.css'
import { CanvasRenderer } from 'echarts/renderers'
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, PieChart, GaugeChart, LineChart  } from 'echarts/charts';
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent
} from 'echarts/components'
import '@/assets/fonts/fonts.css'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale,
    LinearScale, PointElement, LineElement, LineController
}
    from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
    PointElement, LineElement, LineController
)
ChartJS.register(ChartDataLabels);

const app = createApp(App)

app.use(router)
app.use(Ant)


// 按需注册的组件
echarts.use([
    CanvasRenderer,     // 渲染器
    BarChart,   // 柱状图
    PieChart,    // 饼图
    LineChart,      // 折线图
    GaugeChart,
    ToolboxComponent,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent
]);
app.config.globalProperties.$echarts = echarts
// 挂载一个自定义属性$axios
app.config.globalProperties.$axios = axios_service
// 挂载global_utils.js中的全局函数
app.config.globalProperties.$global_utils = global_utils


const icons = Icons
for (const i in icons){
    app.component(i, icons[i])
}
app.mount('#app')

// 路由守卫
router.beforeEach((to, from, next)=>{
    if (to.meta.authentication_skip == true ) {
        next()
        return
    }
    let user_token = sessionStorage.getItem('Authorization')
    let user_data = JSON.parse(sessionStorage.getItem('user_data'))
    if(!user_token){
        message.warning('The authentication has expired, please log in again.')
        next('/login')
        return
    }
    if(to.meta.role){
        if(!to.meta.role.includes(user_data.role_id)){
            message.warning('Permission is not passed.')
            return
        }
    }
    next()
})